<template>
    <confirm-dialog :open="confirmClearOpen" :header="confirmClear.header"
                    @reply="processConfirm" query-parameter="confirmBewerbStatus">
        {{ confirmClear.question }}
    </confirm-dialog>
</template>

<script>
import ConfirmDialog from "@/components/navigation/confirmDialog.vue";

export default {
    name: "spielKoClear",
    components: {ConfirmDialog},
    props: ['spiel', 'runde', 'bewerb', 'confirmClearOpen'],
    data: () => ({
        confirmClear: {
            header: 'Spiel leeren',
            question: 'Möchtest du wirklich alle Teams und etwaige Ergebnisse für dieses Spiel löschen? ' +
                'Diese Aktion kann nicht rückgängig gemacht werden.',
        },
    }),
    methods: {
        async processConfirm(reply) {
            if ( reply ) {
                this.spiel.clear();
                const spiel = JSON.parse(JSON.stringify(this.spiel))
                this.bewerb.update({ ['runden.' + this.runde.id + '.spiele.' + spiel.id]: spiel })
            }
            this.$emit('closeClear');
        },
    },
}
</script>

<style scoped>

</style>